import type { KYDEventRefundExecution } from "@common/interfaces/KYDEvent";
import { refundExecutionCanAbort } from "@common/services/refundExecutionWait";

/** Fetched `can_abort` is a snapshot. Re-check `wait_until` against `now`. */
export const refundAbortStillOpen = (
  execution: KYDEventRefundExecution | undefined,
  now = Date.now()
): boolean =>
  execution?.can_abort === true && refundExecutionCanAbort(execution, now);
